// ./utils/edgeUtils.js
import { normalizeEdgeRoutingMode } from "./customEdgeGeometry.js";
import { ensureColorContrast, getMapTheme, relationshipColorAssignments } from "./mapThemes.js";
import {
  normalizeEdgeStrength,
  resolveRelationshipPresentation,
} from "./relationshipStrength.js";

export function markReciprocalEdges(edges) {
  const directions = new Set(
    edges.map((edge) => `${String(edge.source)}\u0000${String(edge.target)}`)
  );

  return edges.map((edge) => ({
    ...edge,
    data: {
      ...edge.data,
      routing: normalizeEdgeRoutingMode(
        edge.data?.routing || edge.style?.routing
      ),
      reciprocal:
        String(edge.source) !== String(edge.target) &&
        directions.has(`${String(edge.target)}\u0000${String(edge.source)}`),
    },
  }));
}

export function assignEdgeColors(edges, colorMode, canvasStyle, relationshipWeight = "standard", themeTokens = null) {
  const baseTheme = getMapTheme(colorMode, canvasStyle);
  const theme = {
    ...baseTheme,
    edgeStyle: { ...baseTheme.edgeStyle, ...(themeTokens?.edgeStyle || {}) },
    relationshipLabelStyle: { ...baseTheme.relationshipLabelStyle, ...(themeTokens?.relationshipLabelStyle || {}) },
  };
  const edgeOpacity = Math.max(0.78, theme.edgeStyle.opacity);
  const canvasBackground = themeTokens?.background || theme.background;
  const colorKeys = edges.map((edge) => String(edge.label || "").trim() || edge.id || "relationship");
  const colors = relationshipColorAssignments(colorKeys, colorMode, canvasStyle);

  return markReciprocalEdges(edges).map((edge) => {
    const label = edge.label || "";
    const colorKey = String(label).trim() || edge.id || "relationship";
    const paletteColor = theme.edgeStyle.colorMode === "monochrome"
      ? theme.text || theme.nodeBorder || "#455260"
      : colors.get(colorKey.toLowerCase()) || colors.get("relationship");
    const color = ensureColorContrast(paletteColor, canvasBackground, 3, edgeOpacity);
    const strength = normalizeEdgeStrength(edge.style?.strength);
    const presentation = resolveRelationshipPresentation(strength, relationshipWeight);

    return {
      ...edge,
      type: "customOffset",
      label,
      data: {
        ...edge.data,
        themeEdgeOpacity: edgeOpacity,
        relationshipLabelStyle: theme.relationshipLabelStyle,
      },
      style: {
        ...edge.style,
        strength,
        stroke: color,
        strokeWidth: presentation.width * theme.edgeStyle.widthScale,
        opacity: edgeOpacity,
        strokeDasharray: presentation.dasharray,
      },
      markerEnd: {
        type: "arrowclosed",
        color,
        width: presentation.markerSize * theme.edgeStyle.markerScale,
        height: presentation.markerSize * theme.edgeStyle.markerScale,
      },
    };
  });
}
